import React, { useState } from 'react';
import { Avatar } from '../../Components/Avatar';
import { Divider } from '../../Components/Divider';
import { FormContainer } from '../../Components/FormContainer';
import { Grid } from '../../Components/Grid';
import { GridItem } from '../../Components/GridItem';
import { Paper } from '../../Components/Paper';
import { Select } from '../../Components/Select';
import { Space } from '../../Components/Space';
import { TextArea } from '../../Components/TextArea';
import { TextField } from '../../Components/TextField';
import { Typography } from '../../Components/Typography';

import Modal from 'react-modal';
import avatarProfile from '../../Assets/Images/avatar.jpg';
import { Alert } from '../../Components/Alert';
import { Box } from '../../Components/Box';
import Loading from '../../Components/Loading';
import ProfileHooks from '../../hooks/ProfileHooks';
import EditAvatar from './components/edit-avatar/edit-avatar';
import { Container, ImageBackground, SubmitInput } from './profile.styled';
import { getFromApi, savedFromApi } from './actions';
import { useEffect } from 'react';
import buildForm from '../../hooks/buildForm';
import { GlobalMessageContext } from '../../context/GlobalMessage';
import { useContext } from 'react';
import parseErrorClient from '../../utils/parseErrorClient';

const Profile = () => {
  // const { loadingr, handleProfile, profile, response } = ProfileHooks();
  const { setNotification } = useContext(GlobalMessageContext);
  const [modalIsOpen, setIsOpen] = useState(false);
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const [response, setResponse] = useState();

  function openModal() {
    setIsOpen(true);
  }

  function closeModal() {
    setIsOpen(false);
  }

  const customStyles = {
    overlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(21, 22, 27, 0.8)',
      zIndex: 20,
    },
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      zIndex: '1000',
    },
  };

  const handleProfile = async event => {
    event.preventDefault();

    try {
      setLoading(true);
      if (!loading) {
        setData(
          await savedFromApi({ setLoading, data: buildForm(event.target) }),
        );

        const textNotification = 'Perfil atualizado com sucesso!';
        setResponse(textNotification);

        setNotification({ context: 'success', text: textNotification });
        setLoading(false);
      }
    } catch (error) {
      const message = parseErrorClient(error, setLoading);
      setNotification(message);
      setResponse(`Ocorreu um erro detalhes: ${message.text}`);
    }
  };

  useEffect(() => {
    const data = async () => {
      setData(await getFromApi({ setLoading, setNotification }));
    };
    data();
  }, [getFromApi, setData]);

  return (
    <>
      <Container>
        <Modal
          isOpen={modalIsOpen}
          onRequestClose={closeModal}
          style={customStyles}
          contentLabel="Example Modal"
        >
          <EditAvatar
            profile={data}
            closeModal={closeModal}
            handleProfile={handleProfile}
            loading={loading}
          />
        </Modal>
        <ImageBackground />
        {loading && Object.keys(data) === 0 ? (
          <Loading label={loading} />
        ) : (
          <Content
            openModal={openModal}
            loading={loading}
            handleProfile={handleProfile}
            profile={data}
            response={response}
          />
        )}
      </Container>
    </>
  );
};

const Content = props => (
  <>
    <Box position="absolute" top="100px" left="24px">
      <Typography className="text-white" tagName="h3">
        {/* Hello */}
      </Typography>

      <Typography className="text-white" tagName="p">
        {/* Lorem ipsum dolor sit amet consectetur adipisicing elit. Nemo, quaerat? */}
      </Typography>
      {/*<Button className="mt-1">Editar Perfil</Button>*/}
    </Box>
    <Box position="absolute" top="200px" left="0">
      <Grid>
        <SideContent {...props} />
        <EditFormContent {...props} />
      </Grid>
    </Box>
  </>
);

const EditFormContent = ({ loading, handleProfile, profile, response }) => {
  const [selectObj, setSelectObj] = useState({});

  useEffect(() => {
    setSelectObj({
      occupation: profile.occupation,
      contactPreference: profile.contactPreference,
      acceptFreelanceWork:
        profile.acceptFreelanceWork === true
          ? 'yes'
          : profile.acceptFreelanceWork === false
          ? 'no'
          : null,
    });
  }, [profile]);
  return (
    <GridItem md="8" xs="12">
      <Paper>
        {console.log('data', profile)}
        <Typography tagName="h3" upper className="text-muted">
          Editar Perfil
        </Typography>
        <Divider />
        <NoRegistrationAlert profileId={profile.profileId} />
        <FormContainer onSubmit={handleProfile}>
          <Grid>
            <GridItem md="6" xs="12">
              <TextField
                placeholder="ada"
                label="Username"
                name="username"
                disabled
                defaultValue={profile.username}
              />
            </GridItem>
            <GridItem md="6" xs="12">
              <TextField
                placeholder="micke@email.com"
                disabled
                label="Email Address"
                name="email"
                defaultValue={profile.email}
              />
            </GridItem>
            <GridItem md="6" xs="12">
              <TextField
                placeholder="Ada Lovelace"
                label="Preference Name*"
                name="preferenceName"
                defaultValue={profile.preferenceName}
                required
              />
            </GridItem>
            <GridItem md="6" xs="12">
              <TextField
                placeholder="Byron King"
                label="Last Name"
                name="lastName"
                defaultValue={profile.lastName}
              />
            </GridItem>
            <GridItem md="12" xs="12">
              <Typography tagName="h3" upper className="text-muted">
                Contact information
              </Typography>
            </GridItem>
            <Divider />

            <GridItem md="4" xs="12">
              <Select
                name="occupation"
                label="Occupation"
                value={selectObj.occupation}
                onChange={e =>
                  setSelectObj({ ...selectObj, occupation: e.target.value })
                }
                items={[
                  {
                    label: 'PJ',
                    value: 'PJ',
                  },
                  {
                    label: 'CLT',
                    value: 'CLT',
                  },
                  {
                    label: 'Estágiario',
                    value: 'ESTAGIARIO',
                  },
                  {
                    label: 'Trainne',
                    value: 'TRAINNE',
                  },
                  {
                    label: 'Estudante',
                    value: 'ESTUDANTE',
                  },
                ]}
              />
            </GridItem>
            <GridItem md="4" xs="12">
              <Select
                name="acceptFreelanceWork"
                label="Accept Freelance Work"
                value={selectObj.acceptFreelanceWork}
                onChange={e =>
                  setSelectObj({
                    ...selectObj,
                    acceptFreelanceWork: e.target.value,
                  })
                }
                items={[
                  {
                    label: 'Yes',
                    value: 'yes',
                  },
                  {
                    label: 'No',
                    value: 'no',
                  },
                ]}
              />
            </GridItem>
            <GridItem md="4" xs="12">
              <Select
                name="contactPreference"
                label="Contact Preference"
                value={selectObj.contactPreference}
                onChange={e =>
                  setSelectObj({
                    ...selectObj,
                    contactPreference: e.target.value,
                  })
                }
                items={[
                  {
                    label: 'Whatsapp',
                    value: 'WHATSAPP',
                  },
                  {
                    label: 'Telegram',
                    value: 'TELEGRAM',
                  },
                  {
                    label: 'Email',
                    value: 'EMAIL',
                  },
                ]}
              />
            </GridItem>
            <GridItem md="12" xs="12">
              <TextField
                placeholder="javascript,css,html,design"
                label="Skills"
                name="skills"
                defaultValue={profile.skills?.join(',')}
              />
              <p>*mínimo 3 skills, dividindo por vírgula</p>
            </GridItem>
            <GridItem md="12" xs="12">
              <TextField
                placeholder="Software Engineer"
                label="Current position"
                name="currentPosition"
                defaultValue={profile.currentPosition}
              />
            </GridItem>
            <GridItem md="12" xs="12">
              <TextField
                placeholder="codivas"
                label="Github User"
                name="githubUsername"
                defaultValue={profile.githubUsername}
              />
            </GridItem>
            <Divider />
            <Grid>
              <GridItem md="6" xs="12">
                <TextField
                  placeholder="/in/profile/"
                  label="Linkedin"
                  name="linkedin"
                  defaultValue={profile.linkedin}
                  required
                />
              </GridItem>
              <GridItem md="6" xs="12">
                <TextField
                  placeholder="@profile"
                  label="Instagram"
                  name="instagram"
                  defaultValue={profile.instagram}
                />
              </GridItem>
            </Grid>
            <GridItem md="12" xs="12">
              <Typography tagName="h3" upper className="text-muted">
                Address information
              </Typography>
            </GridItem>
            <Divider />
            <GridItem md="5" xs="12">
              <TextField
                placeholder="São Paulo"
                label="City"
                name="city"
                defaultValue={profile.city}
              />
            </GridItem>
            <GridItem md="5" xs="12">
              <TextField
                placeholder="Brasil"
                label="Country"
                name="country"
                defaultValue={profile.country}
              />
            </GridItem>
            <GridItem md="2" xs="12">
              <TextField
                placeholder="SP"
                label="UF"
                name="uf"
                defaultValue={profile.uf}
              />
            </GridItem>
            <Typography tagName="h3" upper className="text-muted">
              About me
            </Typography>
            <Divider />
            <GridItem md="12">
              <TextArea
                label="About Me"
                placeholder="A beautiful..."
                rows="5"
                name="bio"
                defaultValue={profile.bio}
              ></TextArea>
            </GridItem>
          </Grid>
          <Grid>
            <Divider />
            <GridItem md="12">
              <SubmitInput
                type="submit"
                name=""
                loading={loading}
                value={loading ? 'Carregando...' : 'Salvar'}
              />
            </GridItem>
          </Grid>
        </FormContainer>
      </Paper>
    </GridItem>
  );
};

const SideContent = ({ profile, openModal }) => (
  <GridItem md="4" xs="12">
    <Paper position="relative">
      <Avatar openModal={openModal} src={profile?.avatarUrl || avatarProfile} />
      <Space height="70" />
      <Grid>
        <GridItem md="4" xs="4">
          {/* <p className="text-center text-muted">Amigos</p> */}
        </GridItem>
        <GridItem md="4" xs="4">
          {/* <p className="text-center text-muted">Fotos</p> */}
        </GridItem>
        <GridItem md="4" xs="4">
          {/* <p className="text-center text-muted">Cometarios</p> */}
        </GridItem>
      </Grid>
      <Typography tagName="h6" center>
        Codiva
      </Typography>
      <Typography tagName="p" center>
        Brasil
      </Typography>
      <Typography tagName="h6" center>
        {/* Colectiva Codivas */}
      </Typography>
      <Typography tagName="h6" center>
        {/* Colectiva Codivas */}
      </Typography>
      <Divider />
      <Typography tagName="p">{profile.bio}</Typography>
      {/* <a href="#">Show more</a> */}
    </Paper>
  </GridItem>
);

const NoRegistrationAlert = ({ profileId }) => {
  if (profileId) return <></>;
  return (
    <GridItem>
      <Alert variant={'info'}>
        <Typography weight={400}>
          Complete o cadastro do seu perfil e junte-se as Codivas{' '}
        </Typography>
      </Alert>
    </GridItem>
  );
};
export default Profile;
